import { graphql } from "gatsby";
import React from "react";
import SEO from "../components/common/SEO";
import { Hero1, Hero2, HeroLoad } from "../components/home/";
import HeroMobile from "../components/home/hero/heroMobile";
import { useWindowDimension } from "../components/utils/useWindowDimension";
import BlogSection from "../components/home/blog";
import LoginSection from "../components/home/LoginSection";
import SliderHero from "../components/home/hero/SliderHero";
import Menu from "../components/home/menu";
import DownloadApp from "../components/home/downloadapp";
import Collections from "../components/home/collections";
import FaqSection from "../components/home/faqSection";

const Home = ({ data }) => {
  const landingPage = data.sanityLandingPage;
  const { width } = useWindowDimension();

  return (
    <div>
      {landingPage.hero_section === "heroWithVideo" &&
        (width === null ? (
          <HeroLoad
            title={landingPage.heroWithVideo.title}
            subTitle={landingPage.heroWithVideo.subTitle}
            color={landingPage.heroWithVideo.textColor.hex}
          />
        ) : width > 860 ? (
          <Hero2 data={landingPage.heroWithVideo} />
        ) : (
          <HeroMobile data={landingPage.heroWithVideo} />
        ))}
      {landingPage.hero_section === "heroWithImage" && (
        <>
          <div className="hidden min-[860px]:block">
            <Hero1 data={landingPage.heroWithImage} />
          </div>
          <div className="block min-[860px]:hidden">
            <HeroMobile data={landingPage.heroWithImage} />
          </div>
        </>
      )}
      {landingPage.hero_section === "heroWithSlider" && (
        <SliderHero data={landingPage.heroWithSlider} />
      )}

      <LoginSection data={landingPage.login} />
      <Menu data={landingPage.menuSection} />
      <DownloadApp data={landingPage.downloadSection} />
      <Collections data={landingPage.locationSection} />
      <BlogSection data={landingPage.cateringSection} />
      <FaqSection data={landingPage.faqSection} />
    </div>
  );
};

export default Home;

export function Head({ location, data }) {
  return <SEO location={location} data={data?.sanityLandingPage?.seo} />;
}

export const query = graphql`
  {
    sanityLandingPage {
      seo {
        title
        description
        keywords
      }
      id
      hero_section
      heroWithImage {
        title
        subTitle
        mobileSubTitle
        textColor {
          hex
        }
        textAlignment
        bgImageMobile {
          asset {
            gatsbyImageData(
              formats: WEBP
              layout: CONSTRAINED
              placeholder: BLURRED
            )
            url
          }
        }
        bgImageDesktop {
          asset {
            gatsbyImageData(
              formats: WEBP
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
            url
          }
        }
        bgOverlay {
          rgb {
            r
            g
            b
            a
          }
        }
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
      }
      heroWithSlider {
        ... on SanityHeroWithImage {
          _type
          title
          subTitle
          mobileSubTitle
          textColor {
            hex
          }
          textAlignment
          bgImageMobile {
            asset {
              gatsbyImageData(
                formats: WEBP
                layout: CONSTRAINED
                placeholder: BLURRED
              )
              url
            }
          }
          bgImageDesktop {
            asset {
              gatsbyImageData(
                formats: WEBP
                layout: FULL_WIDTH
                placeholder: BLURRED
              )
              url
            }
          }
          bgOverlay {
            rgb {
              r
              g
              b
              a
            }
          }
          button {
            buttonText
            buttonType
            buttonColor
            linkType
            pdf {
              asset {
                url
              }
            }
            slug {
              current
            }
            url
          }
        }
        ... on SanityHeroWithVideo {
          _type
          title
          subTitle
          textColor {
            hex
          }
          textAlignment
          video {
            asset {
              title
              url
            }
          }
          bgOverlay {
            rgb {
              r
              g
              b
              a
            }
          }
          button {
            buttonText
            buttonType
            buttonColor
            linkType
            pdf {
              asset {
                url
              }
            }
            slug {
              current
            }
            url
          }
        }
      }
      heroWithVideo {
        title
        subTitle
        textColor {
          hex
        }
        textAlignment
        video {
          asset {
            title
            url
          }
        }
        bgOverlay {
          rgb {
            r
            g
            b
            a
          }
        }
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
      }
      login {
        sectionId
        title
        icon {
          alt
          asset {
            gatsbyImageData(
              layout: CONSTRAINED
              formats: [WEBP, AUTO]
              placeholder: BLURRED
            )
          }
        }
        button1 {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
        button2 {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
      }
      menuSection {
        sectionId
        title
        leftIcon {
          asset {
            url
          }
        }
        rightIcon {
          asset {
            url
          }
        }
        subTitle
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
        categories {
          id
          name
          subtitle
          linkType
          slug {
            current
          }
          url
          firstImage {
            asset {
              filename
              gatsbyImageData(placeholder: BLURRED, formats: WEBP)
            }
          }
          secondImage {
            asset {
              filename
              gatsbyImageData(placeholder: BLURRED, formats: WEBP)
            }
          }
        }
      }
      downloadSection {
        sectionId
        title
        leftIcon {
          asset {
            url
          }
        }
        rightIcon {
          asset {
            url
          }
        }
        subTitle
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
        button2 {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
        image {
          alt
          asset {
            gatsbyImageData(
              layout: CONSTRAINED
              formats: [WEBP, AUTO]
              placeholder: BLURRED
            )
          }
        }
        image2 {
          alt
          asset {
            gatsbyImageData(
              layout: CONSTRAINED
              formats: [WEBP, AUTO]
              placeholder: BLURRED
            )
          }
        }
      }
      locationSection {
        sectionId
        title
        leftIcon {
          asset {
            url
          }
        }
        rightIcon {
          asset {
            url
          }
        }
        subTitle
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
        locations {
          title
          shopImage {
            alt
            asset {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: BLURRED
                formats: [WEBP, AUTO]
              )
            }
          }
          icon {
            alt
            asset {
              gatsbyImageData(
                layout: CONSTRAINED
                formats: [WEBP, AUTO]
                placeholder: BLURRED
              )
            }
          }
          slug {
            current
          }
        }
      }
      cateringSection {
        sectionId
        title
        leftIcon {
          asset {
            url
          }
        }
        rightIcon {
          asset {
            url
          }
        }
        _rawDescription
        textColor {
          hex
        }
        bgImage {
          asset {
            gatsbyImageData(
              formats: WEBP
              layout: FULL_WIDTH
              placeholder: BLURRED
            )
          }
        }
        button {
          buttonText
          buttonType
          buttonColor
          linkType
          pdf {
            asset {
              url
            }
          }
          slug {
            current
          }
          url
        }
      }
      faqSection {
        sectionId
        title
        leftIcon {
          asset {
            url
          }
        }
        rightIcon {
          asset {
            url
          }
        }
        faqs {
          question
          _rawAnswer
        }
      }
    }
  }
`;
